import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountFioVersionMigrationStatusQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountFioVersionMigrationStatusQuery = { __typename?: 'Query', fioVersionMigration?: { __typename?: 'FioVersionMigration', status?: { __typename: 'FioVersionMigrationBlocked' } | { __typename: 'FioVersionMigrationEligible' } | { __typename: 'FioVersionMigrationFailed' } | { __typename: 'FioVersionMigrationInProgress' } | { __typename: 'FioVersionMigrationIneligible' } | { __typename: 'FioVersionMigrationMigrated' } | { __typename: 'FioVersionMigrationMustMigrate' } | { __typename: 'FioVersionMigrationPending' } | { __typename: 'FioVersionMigrationRollingBack' } | { __typename: 'FioVersionMigrationStatusUnknown' } | null } | null };


export const GetAccountFioVersionMigrationStatus = /*#__PURE__*/ gql`
    query GetAccountFioVersionMigrationStatus($accountId: ID!) {
  fioVersionMigration(accountId: $accountId) {
    status {
      __typename
    }
  }
}
    ` as unknown as DocumentNode<GetAccountFioVersionMigrationStatusQuery, GetAccountFioVersionMigrationStatusQueryVariables>;

          

          export const useGetAccountFioVersionMigrationStatusQuery = (options?:QueryHookOptions<GetAccountFioVersionMigrationStatusQuery, GetAccountFioVersionMigrationStatusQueryVariables>) => useQuery(GetAccountFioVersionMigrationStatus, options);

          

          export type GetAccountFioVersionMigrationStatusQueryOptions = QueryHookOptions<GetAccountFioVersionMigrationStatusQuery, GetAccountFioVersionMigrationStatusQueryVariables>;

          

          export const useGetAccountFioVersionMigrationStatusLazyQuery = (options?:LazyQueryHookOptions<GetAccountFioVersionMigrationStatusQuery, GetAccountFioVersionMigrationStatusQueryVariables>) => useLazyQuery(GetAccountFioVersionMigrationStatus, options);

          

          export type GetAccountFioVersionMigrationStatusQueryResult = ReturnType<typeof useGetAccountFioVersionMigrationStatusQuery>;

          
